import React, { Component } from 'react';
import $ from 'jquery';
import renderHTML from 'react-render-html';
import { SurveyQuestion, DoesNotApplyOption } from '../questionComponents';

class Alphanumeric extends React.Component {
  constructor(props) {
    super(props);
    let { Response } = props.survey;
    this.state = {
      value: Response,
    };
  }
  onChange = (event, click) => {
    const { value } = event.target;
    // const { SurveyQuestionId } = this.props.survey;
    let valueStr = value !== '' ? value : null;
    this.setState({
      value: valueStr,
    });
  };
  render() {
    const {
      survey,
      onClick,
      scope,
      index,
      total,
      setValue,
      level,
      subLevel,
      subCatLevel,
      isReadOnly,
    } = this.props;
    const {
      Question,
      QuestionNumber,
      DoesNotApplyText,
      DoesNotApplyValue,
      SurveyQuestionId,
      Response,
    } = survey;
    return (
      <>
        <div
          // className="card border-0"
          className="type-border col-sm-12 col-lg-6"
        >
          <div class="answer-options text-left mb-0 pb-0 d-flex flex-column">
            <SurveyQuestion survey={survey} ClassName={'d-inline'} />
            <div class="quantity-btn d-inline mb-3">
              <div class="numbers-row">
                <input
                  disabled={isReadOnly}
                  type="text"
                  value={this.state.value}
                  tabindex="0"
                  placeholder="Enter Answer"
                  // style={{ textAlign: 'center', paddingLeft: '10px' }}
                  className="alphanumeric-type"
                  onChange={this.onChange}
                  onBlur={() => {
                    setValue.call(scope, {
                      response: this.state.value,
                      surveyQuestionId: SurveyQuestionId,
                      level: level,
                      subLevel: subLevel,
                      subCatLevel: subCatLevel,
                      index: index,
                    });
                  }}
                />
              </div>
            </div>

            {/* <div class="row">
              <div class="col-12 text-right">
                <button class="btn" onClick={onClick.bind(this)}>
                  Next
                </button>
              </div>
            </div> */}
            <DoesNotApplyOption surveyProps={this.props} />
          </div>
        </div>
        {/*     
        <div class="survey-box" style={{ width: '100%', display: 'inline-block;' }}>
          <h2>{Question}</h2>
          <div class="survey-form-box">
            <div class="survey-form-left">
              <div class="form-group survey-textinput">
                <div class="input-group">
                  <input class="form-control" type="text" style={{ textAlign: 'center' }} />
                </div>
              </div>
              <span class="small-text" />
            </div>
            <div class="survey-form-right">
              <input
                type="button"
                class="form-control survey-form-btn"
                value="Next"
                tabindex="0"
                onClick={onClick.bind(this)}
              />
            </div>
            <div class="clearfix" />
          </div>
        </div> */}
      </>
    );
  }
}
export default Alphanumeric;
